<template>
  <div class="content-8__content">
    <loading v-if="isLoading" />
    <table v-else class="even-color">
      <template v-if="tableList.length > 0">
        <thead>
          <tr>
            <template v-for="(item, index) in tableHead">
              <th v-if="index === 2" :key="`tableHead-${index}`">
                <div class="tablebtnbox">
                  <a
                    v-for="(btn, btnIndex) in item"
                    :key="`btn-${btn.key}-${btnIndex}`"
                    class="button-outline tablebtnbox__item"
                    :class="{ active: btn.key === activeTableBtnKey }"
                    @click="changeBtn(btn)"
                  >
                    <span class="button-outline__text">{{ btn.name }}</span>
                  </a>
                </div>
              </th>
              <th v-else :key="`tableHead-${index}`" :colspan="item.col">
                <span>{{ item.name }}</span>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in tableList"
            :key="`trend-${item.period}-${index}`"
          >
            <td>
              <span>{{ item.drawTime }}</span>
            </td>
            <td>
              <span>{{ item.period }}</span>
            </td>
            <td>
              <LotteryBallList
                :list="item.ballsInfo"
                :current-label="activeTableBtnKey"
                :lottery-type="lotteryType"
                :lottery-code="lotteryCode"
              />
            </td>

            <td
              v-for="(extraInfo, extraInfoIndex) in item.extraList"
              :key="`extraInfo-${extraInfoIndex}`"
              :class="extraInfo.colorClass"
            >
              <span v-text="extraInfo.label"></span>
            </td>
          </tr>
        </tbody>
      </template>
      <NoData v-else />
    </table>
    <ClickMoreBtn v-if="moreBtnExists" :btn-hide="noMoreData" @show-more="showMoreInfo" />
  </div>
</template>

<script>
import { getLotteryRuleList } from '@/utils/kaiJiang-Sean'
import { getRuleDetails_desktop } from '@/api/desktop/basic'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import LotteryBallList from '@/components/web/pages/trend/JiShihKaiJiang/LotteryBallList'
import * as moment from 'moment-mini'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import ClickMoreBtn from '@/components/web/pages/trend/ClickMoreBtn'
import chunk from 'lodash.chunk'
export default {
  name: 'KaiJiangTable',
  components: {
    LotteryBallList,
    Loading,
    NoData,
    ClickMoreBtn
  },
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('KaiJiangTable required key "lotteryCode"')
        return ''
      }
    },
    periodFormat: {
      type: Object,
      required: true,
      default: () => {
        console.error('KaiJiangTable required key "periodFormat"')
        return {}
      }
    },
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      tableList: [],
      lotteryRuleList: getLotteryRuleList(this.lotteryType),
      tableButtonBox: [
        { name: '显示号码', active: true, key: 'hm' },
        { name: '显示大小', active: false, key: 'daXiao' },
        { name: '显示单双', active: false, key: 'danShuang' }
      ],
      activeTableBtnKey: 'hm',
      routeName: this.$route.name,
      isLoading: false,
      chunkInfo: {
        lists: [],
        index: 0,
        last: 0,
        isLast: false
      }
    }
  },
  computed: {
    tableHead() {
      let result = []
      switch (this.lotteryType) {
        case 'pk10':
          result = [
            { name: '时间', col: 1 },
            { name: '期数', col: 1 },
            this.tableButtonBox,
            { name: '冠亚和', col: 3 },
            { name: '1-5龙虎', col: 5 }
          ]
          break
        case 'ssc':
        case '11x5':
          result = [
            { name: '时间', col: 1 },
            { name: '期数', col: 1 },
            this.tableButtonBox,
            { name: '总和', col: 3 },
            { name: '1-5龙虎', col: 1 },
            { name: '前三', col: 1 },
            { name: '中三', col: 1 },
            { name: '后三', col: 1 }
          ]
          break
        case 'kl10':
          result = [
            { name: '时间', col: 1 },
            { name: '期数', col: 1 },
            this.tableButtonBox,
            { name: '总和', col: 3 },
            { name: '尾大小', col: 1 },
            { name: '龙虎', col: 4 }
          ]
          break
      }
      return result
    },
    noMoreData() {
      return this.chunkInfo.isLast
    },
    moreBtnExists() {
      return !this.isLoading && this.tableList.length > 0
    }
  },
  watch: {
    periodFormat: {
      handler() {
        this.getTableList()
      },
      deep: true
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    makeBallsInfo(item, array) {
      const result = (array.fill().map((info, index) => {
        const ballNumber = item.balls[index]

        const label = {}
        const twoSides = {}

        const defaultClass = []

        label.hm = {
          label: item.balls[index],
          className: defaultClass.slice(),
          showText: true
        }
        label.daXiao = {
          label: this.formatRuleCode(item.hmDaXiao[index]),
          className: defaultClass.slice(),
          showText: true
        }
        label.danShuang = {
          label: this.formatRuleCode(item.hmDanShuang[index]),
          className: defaultClass.slice(),
          showText: true
        }

        twoSides.isDa = label.daXiao.label === '大'
        twoSides.isXiao = label.daXiao.label === '小'
        twoSides.isDan = label.danShuang.label === '单'
        twoSides.isShuang = label.danShuang.label === '双'
        twoSides.isHe = label.danShuang.label === '和'

        if (twoSides.isDa) {
          label.daXiao.className.push('color--orange')
        } else if (twoSides.isXiao) {
          label.daXiao.className.push('color--gray')
        } else {
          label.daXiao.className.push('color--blue')
        }

        if (twoSides.isShuang) {
          label.danShuang.className.push('color--orange')
        } else if (twoSides.isDan) {
          label.danShuang.className.push('color--gray')
        } else {
          label.danShuang.className.push('color--blue')
        }

        switch (this.lotteryCode) {
          case 'cqxync': // 重慶訊農場
            label.hm.className.push(`haomaimg-${ballNumber}`)
            label.hm.showText = false
            break
          case 'cqssc': // 重慶時時彩
            label.hm.className.push(`zodiac-${ballNumber}`)
            label.hm.showText = false
            break
          default:
        }

        switch (this.lotteryType) {
          case 'pk10':
            if (item.balls[index] < 10) {
              label.hm.className.push(`ball-0${ballNumber}`)
            } else {
              label.hm.className.push(`ball-${ballNumber}`)
            }
            break

          case 'ssc':
          case '11x5':
          case 'kl10':
            label.hm.className.push('circle', 'color--primary')
            break
        }

        label.hm.className = label.hm.className.join(' ')
        label.daXiao.className = label.daXiao.className.join(' ')
        label.danShuang.className = label.danShuang.className.join(' ')

        return {
          ball: label,
          twoSides,
          isOpacity: false
        }
      }))
      return result
    },
    async getTableList() {
      this.isLoading = true
      this.resetChunkInfo()

      const query = {
        rules: this.lotteryRuleList
      }

      switch (this.$route.query.trendType) {
        case 'LiShihKaiJiang': // 歷史開獎
          Object.assign(query, { ...this.periodFormat })
          break
        default:
          Object.assign(query, { date: moment().format('YYYY-MM-DD') })
          break
      }

      const [data, error] = await getRuleDetails_desktop(this.lotteryCode, query)
      if (error) return

      data.forEach(item => {
        let extraList = []

        // period
        item.drawTime = this.formatDrawTime(item.drawTime)

        let array
        switch (this.lotteryType) {
          case 'pk10':
            extraList.push({
              label: item.guanYaHe,
              colorClass: ''
            })
            extraList.push({
              label: this.formatRuleCode(item.guanYaHeDaXiao[0]),
              colorClass: item.guanYaHeDaXiao[0] === 'daXiao_da' ? 'red' : 'blue'
            })
            extraList.push({
              label: this.formatRuleCode(item.guanYaHeDanShuang[0]),
              colorClass: item.guanYaHeDanShuang[0] === 'danShuang_shuang' ? 'red' : 'blue'
            })
            extraList = extraList.concat(item.zuLongHu.map((zuLongHuItem) => {
              return {
                label: this.formatRuleCode(zuLongHuItem),
                colorClass: zuLongHuItem === 'longHu_long' ? 'red' : 'blue'
              }
            }))

            array = new Array(10)
            item.ballsInfo = this.makeBallsInfo(item, array)
            break
          case 'ssc':
          case '11x5':
            extraList.push({
              label: item.zongHe[0],
              colorClass: ''
            })
            extraList.push({
              label: this.formatRuleCode(item.zongHeDaXiao[0]),
              colorClass: item.zongHeDaXiao[0] === 'daxiao_da' ? 'red' : 'blue'
            })
            extraList.push({
              label: this.formatRuleCode(item.zongHeDanShuang[0]),
              colorClass: item.zongHeDanShuang[0] === 'danshuang_shuang' ? 'red' : 'blue'
            })
            extraList.push({
              label: this.formatRuleCode(item.longHu),
              colorClass: item.longHu === 'longHu_long'
                ? 'red'
                : item.longHu === 'longHu_hu'
                  ? 'blue'
                  : 'green'
            })
            extraList = extraList.concat(item.singTai.map((singTaiItem) => {
              return {
                label: this.formatRuleCode(singTaiItem),
                colorClass: singTaiItem === 'puke_shunZih' ? 'red' : 'blue'
              }
            }))

            array = new Array(5)
            item.ballsInfo = this.makeBallsInfo(item, array)
            break
          case 'kl10':
            extraList.push({
              label: item.zongHe[0],
              colorClass: ''
            })
            extraList.push({
              label: this.formatRuleCode(item.zongHeDaXiao[0]),
              colorClass: item.zongHeDaXiao[0] === 'daXiao_da' ? 'red' : 'blue'
            })
            extraList.push({
              label: this.formatRuleCode(item.zongHeDanShuang[0]),
              colorClass: item.zongHeDanShuang[0] === 'danShuang_shuang' ? 'red' : 'blue'
            })
            extraList = extraList.concat(item.zuLongHu.map((zuLongHuItem) => {
              return {
                label: this.formatRuleCode(zuLongHuItem),
                colorClass: zuLongHuItem === 'longHu_long' ? 'red' : 'blue'
              }
            }))

            array = new Array(8)
            item.ballsInfo = this.makeBallsInfo(item, array)
            break
        }

        item.extraList = extraList
      })

      // 對資料切片，以 "顯示更多" 按鈕來決定資料呈現
      Object.assign(this.chunkInfo, this.chunkData(data))
      this.tableList = this.chunkInfo.lists[this.chunkInfo.index] || []

      this.isLoading = false
    },
    formatDrawTime(drawTime) {
      return moment(drawTime).format('YYYY-MM-DD HH:mm:ss')
    },
    formatRuleCode(value) {
      return ruleCodeMapping[value]
    },
    changeBtn(btn) {
      this.activeTableBtnKey = btn.key
    },
    resetChunkInfo() {
      Object.assign(this.chunkInfo, { lists: [], index: 0, last: 0, isLast: false })
    },
    chunkData(data) {
      const lists = chunk(data, 30)
      const index = 0
      const last = lists.length - 1
      const isLast = index >= last
      return { lists, index, last, isLast }
    },
    showMoreInfo() {
      const { last, lists } = this.chunkInfo
      this.chunkInfo.index++
      if (this.chunkInfo.index === last) {
        this.chunkInfo.isLast = true
      }
      this.tableList = this.tableList.concat(lists[this.chunkInfo.index])
    }
  }
}
</script>
